import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import React from 'react';

export const DocumentTemplatesIcon = ({
	bgColor = '#D4DCF5',
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<DescriptionOutlinedIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				p: 0.5,
				color: '#fff',
			}}
		/>
	);
};
